module.exports = __webpack_public_path__ + "static/media/electrolytic-cell.ee22c4b0.jpeg";